// Brand visual assets: auto logo resolution (Clearbit) with elegant text fallback.
// Maps normalized brand names to a domain for logo.clearbit.com.

const BRAND_DOMAINS = {
  'ray ban': 'ray-ban.com',
  'ray ban meta': 'ray-ban.com',
  'maui jim': 'mauijim.com',
  'gucci': 'gucci.com',
  'chloe': 'chloe.com',
  'guess': 'guess.com',
  'vogue': 'vogue-eyewear.com',
  'emporio armani': 'armani.com',
  'etnia barcelona': 'etniabarcelona.com',
  'ferrari scuderia': 'ferrari.com',
  'nike': 'nike.com',
  'police': 'policelifestyle.com',
  'paul & joe': 'paulandjoe.com',
  'paul and joe': 'paulandjoe.com',
  'vanessa bruno': 'vanessabruno.com',
  'jean francois rey': 'jfrey.fr',
  'carven': 'carven.com',
  'julbo': 'julbo.com',
  'kaleos': 'kaleoseyehunters.com',
};

// Premium banner background images (dark, eyewear oriented)
export const BRAND_BANNER_BGS = [
  'https://images.unsplash.com/photo-1511499767150-a48a237f0083?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  'https://images.unsplash.com/photo-1577803645773-f96470509666?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  'https://images.pexels.com/photos/32593246/pexels-photo-32593246.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600',
];

export const normalizeBrand = (name = '') =>
  name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&amp;/g, '&')
    .replace(/\s+/g, ' ')
    .trim();

export const getBrandLogo = (name = '') => {
  const domain = BRAND_DOMAINS[normalizeBrand(name)];
  return domain ? `https://logo.clearbit.com/${domain}` : null;
};

// Per-brand zoom factor: some logos have large internal margins and look too small.
const LOGO_SCALE = {
  'emporio armani': 1.7,
  'etnia barcelona': 1.55,
  'paul & joe': 1.2,
  'jean francois rey': 1.15,
  'vanessa bruno': 1.2,
  'invu': 1.15,
};

export const getBrandLogoScale = (name = '') => LOGO_SCALE[normalizeBrand(name)] || 1;

export const getBrandBanner = (seed = '') => {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return BRAND_BANNER_BGS[h % BRAND_BANNER_BGS.length];
};
